import React, { Component, Fragment} from 'react'
import Breadcrumb from "../../common/breadcrumb"
import Modal from 'react-responsive-modal';
import 'react-toastify/dist/ReactToastify.css';
import Datatable from '../../common/datatable'
import {Link} from 'react-router-dom'
import { getObjects, updateObject, deleteObject } from "../../api";

export class UserList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            loading: true, // set to false once loading is completed
            editingRow: {},
            actionMode: ''
        };
    }

    onOpenModal = () => {
        this.setState({ editingRow: {}, actionMode: 'new', open: true });
    };

    onCloseModal = (mode) => {
        this.setState({ open: false });
        if(mode === true)
        {
            if (document.getElementById("newUser").elements['actionMode'].value === 'new') {
                this.onCreateUser(document.getElementById("newUser").elements['userName'].value);
            } else if (document.getElementById("newUser").elements['actionMode'].value === 'update') {
                this.onUpdateUser(  document.getElementById("newUser").elements['itemId'].value,
                                        document.getElementById("newUser").elements['userName'].value);
            } else {
                this.onDeleteUser(  document.getElementById("newUser").elements['itemId'].value);
            }
        } else {
            console.log('cancel');
        }
    };

    onItemEdit = (row) => {
        this.props.history.push(`/admin/user/edit?pid=${row._id}`)
        //this.setState({editingRow: row, actionMode: 'update', open: true });
    };

    onItemDashboard = (row) => {
        this.props.history.push(`/pages/dashboard?uid=${row._id}`)
        //this.setState({editingRow: row, actionMode: 'update', open: true });
    };

    onItemDelete = (row) => {
        this.setState({editingRow: row, actionMode: 'delete', open: true });        
    };

    onCreateUser = (name) => {
        updateObject('user',  { name }).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.loadUsers();
            }
        });
    };

    onUpdateUser = (id, name) => {
        updateObject('user', { "name": name }, id).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.loadUsers();
                }
            }
        );
    };

    onDeleteUser = (id) => {
        deleteObject('user', id).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.loadUsers();
            }
        });
    };

    loadUsers = () => {
        this.setState({ loading: true});
        getObjects('user').then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ data: d2, loading: false});
            }
        });
    };

    componentDidMount(){
        this.loadUsers();
    }

    render() {
        const { open } = this.state;

        if (this.state.loading) { return null; }
        else {
            setTimeout(function() {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 100);       

        return (
            <Fragment>
                <Breadcrumb title="User List" />
                
                {/* <!-- Container-fluid starts--> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className="btn-popup pull-right">
                                        <Link to="/admin/user/edit">
                                            <button type="button" className="btn btn-primary">Add User</button>  
                                        </Link>                                        
                                        <Modal open={open} onClose={this.onCloseModal} >
                                            <div className="modal-header">
                                                <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                                                {this.state.actionMode==='delete'?'Delete ':this.state.actionMode==='update'?'Update ':'Add '}
                                                User</h5>
                                            </div>
                                            <div className="modal-body">
                                                <form id="newUser">
                                                    <input type="hidden" id="itemId" value={this.state.editingRow._id?this.state.editingRow._id:''} />
                                                    <input type="hidden" id="actionMode" value={this.state.actionMode} />
                                                    <div className="form-group">
                                                        <label htmlFor="recipient-name" className="col-form-label" >User Name :</label>
                                                        <input id="userName" defaultValue={this.state.editingRow.name?this.state.editingRow.name:''} type="text" className="form-control" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="message-text" className="col-form-label">User Image :</label>
                                                        <input className="form-control" id="validationCustom02" type="file" />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-primary" onClick={() => this.onCloseModal(true)}>{this.state.actionMode==='delete'?'Delete':'Save'}</button>
                                                <button type="button" className="btn btn-secondary" onClick={() => this.onCloseModal(false)}>Close</button>
                                            </div>
                                        </Modal>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div id="basicScenario" className="category-table order-table user-list-delete">
                                        <Datatable
                                            multiSelectOption={false}
                                            myData={this.state.data}
                                            columns={['fullname', 'email', 'phone', 'permissions']}     
                                            pageSize={10}
                                            pagination={true}
                                            onItemDelete={this.onItemDelete}
                                            onItemEdit={this.onItemEdit}
                                            onItemDashboard={this.onItemDashboard}    
                                            class="-striped -highlight"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Container-fluid Ends--> */}
            </Fragment>
        )
    }
    }
}

export default UserList





